import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import ShiftCashierHistoryDetails from "./ShiftCashierHistoryDetails"
import ShiftCashierHistorySidebar from "./ShiftCashierHistorySidebar"
import ShiftCashierHistoryTopbar from "./ShiftCashierHistoryTopbar"
import classes from "./index.module.scss"

const ShiftCashierHistory = () => {
  const i18n = useTranslation()[1]

  const [selectedShift, setSelectedShift] = useState(null)
  const [openShiftHistorySidebar, setOpenShiftHistorySidebar] = useState(true)

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["container"]}>
      <ShiftCashierHistorySidebar
        selectedShift={selectedShift}
        setSelectedShift={setSelectedShift}
        openShiftHistorySidebar={openShiftHistorySidebar}
        setOpenShiftHistorySidebar={setOpenShiftHistorySidebar}
      />

      <div
        className={clsx(
          classes["details"],
          isLtr && classes["details-ltr"]
        )}
      >
        <ShiftCashierHistoryTopbar
          setOpenShiftHistorySidebar={setOpenShiftHistorySidebar}
        />
        {
          !!selectedShift &&
          <ShiftCashierHistoryDetails
            selectedShift={selectedShift}
            setOpenShiftHistorySidebar={setOpenShiftHistorySidebar}
          />
        }
      </div>
    </div>
  )
}

export default ShiftCashierHistory